<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>
<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12">
                <div class="title-wrapper">

                    <h1 class="title-default">Configurações do Cadastro de Produtos</h1>
                    <p class="welcome-message">
                        <button mat-icon-button routerLink="../">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Configurações e preferências do cadastro de produtos.
                    </p>

                </div>
            </div>
        </div>
        @if (isLoading) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else {
        <form [formGroup]="form">
            <div class="row">
                <div class="col-12 margin-bottom-25">
                    <mat-form-field appearance="outline">
                        <mat-label>Somar pesos dos produtos</mat-label>
                        <mat-select formControlName="idTipoSomaPeso">
                            @for (item of listaTipoSoma; track item.id) {
                            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                            }
                        </mat-select>
                        <mat-hint>Notas fiscais, propostas comerciais e pedidos de venda</mat-hint>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Código (SKU) do produto</mat-label>
                        <mat-select formControlName="idTipoGeracaoSku">
                            @for (item of listaTipoGeracaoSku; track item.id) {
                            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Cálculo do custo de kits e produtos fabricados</mat-label>
                        <mat-select formControlName="idTipoCustoKitFabricado">
                            @for (item of listaTipoCustoKitFabricado; track item.id) {
                            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <div class="toggle-content">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="isCadastroAutomatico">
                            Cadastrar produtos automaticamente
                        </mat-slide-toggle>
                        <span class="info-text">A partir de compras, vendas e ordens de serviço</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6">
                    <app-select-pesquisavel [control]="getControl('idUnidadeMedidaPadrao')"
                        [offlineList]="listaUnidadeMedida" label="Unidade de medida padrão para novos produtos"
                        idField="id" nameField="descricao" [isOptional]="true">
                    </app-select-pesquisavel>
                </div>
                <div class="col-12 col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>NCM padrão para novos produtos</mat-label>
                        <input matInput type="text" inputmode="numeric" [formControl]="ncmControl"
                            [mask]="masks.ncm" placeholder="Ex: 0101.21.00">
                        <button mat-icon-button matSuffix type="button" matTooltip="Pesquisar NCM"
                            (click)="pesquisarNcm()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <app-select-pesquisavel [control]="getControl('idOrigemMercadoriaPadrao')" [offlineList]="listaOrigemMercadoria"
                        label="Origem padrão para novos produtos" idField="id" nameField="descricao" [isOptional]="true"
                        hint="Origem do produto conforme ICMS">
                    </app-select-pesquisavel>
                </div>
            </div>

        </form>

        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>